import { Box, Container, Grid } from "@mui/material";
import SearchForm from "../components/SearchForm";
import Banners from "../components/Banners";
import { useEffect, useState } from "react";
import axios from "axios";

function Main() {

    const [banners, setBanners] = useState(null);
     
    useEffect(() => {
        axios.get('/api/banners?active.equals=true&text.equals=fobanner')
        .then((res) => {
            if(res.data&&res.data[0]){
                setBanners(res.data[0])
            }
        }).catch((err) => console.log('err', err))
    }, [])

    return (
        <>
            <Box sx={{ pt: 5 }}>

                <Container>


                    <Box sx={{
                        width: '100%',
                        py: 5,
                        backgroundImage: `url('data:${banners?.imageContentType};base64,${banners?.image}')`,
                        backgroundSize: '90%',
                        backgroundPosition: 'right center',
                        backgroundRepeat: 'no-repeat'
                    }}>
                        <Box sx={{ width: {sx: '100%', md: '30%'} }}>
                            <Box sx={{ bgcolor: '#fff', border: '1px solid #333' }}>
                                <SearchForm />
                            </Box>
                        </Box>
                    </Box>


                </Container>

            </Box>
            <Box sx={{ pt: 5, pb: 5 }}>

                <Container>


                    <Banners />


                </Container>

            </Box>
        </>
    );
}

export default Main;
